/* stylelint-disable declaration-empty-line-before */
import styled from 'styled-components';

import { BackgroundElement } from '@/core/interfaces/common';

import mediaQueries from '@/utils/mediaQueries';
import { colors } from '@/utils/constants';
import { hexToRgb } from '@/utils/helpers';

const {
  small,
  tablet,
  desktop,
} = mediaQueries;

const maxDesktopWidth = '1250px';

export const LandingPageWrapper = styled.div<BackgroundElement & { isActionTaken?: boolean }>`
  width: 100%;
  height: 100vh;

  background-color:
    ${(props): string => {
    if (props.isActionTaken) {
      return props.backgroundcolor || colors.white;
    }

    return colors.white;
  }};
  font-family: Roboto, sans-serif;
`;

export const Header = styled.header<BackgroundElement & { isActionTaken?: boolean }>`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: ${props => (props.isActionTaken ? '145px' : 'unset')};
  padding: 0 16px;
  background-color: ${props => props.backgroundcolor};
  color: ${props => props.textcolor};

  @media ${small} {
    align-items: flex-start;
  }

  @media ${tablet} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 10px;
  }

  @media ${desktop} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 10px;
  }
`;

export const LogoWrapper = styled.div`
  position: static;
  top: 10px;
  left: 10px;

  @media ${small} {
    top: 0;
    left: 0;
    margin-bottom: 10px;
  }

  @media ${desktop} {
    width: 100%;
    max-width: ${maxDesktopWidth};
    margin-bottom: 10px;
    padding: 0;
  }
`;

export const StyledWhyTakeActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: unset;
  margin-bottom: 24px;
  padding-top: 24px;
`;

export const FormSection = styled.section<BackgroundElement>`
  margin-top: 24px;
  border-width: 3px;
  border-style: solid;
  border-color: ${props => hexToRgb(props.backgroundcolor || colors.white, '0.15')};
  border-radius: 10px;
  padding: 20px 40px;
  background-color: ${props => hexToRgb(props.backgroundcolor || colors.white, '0.05')};

  @media ${desktop} {
    width: 100%;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${maxDesktopWidth};
  margin-right: auto;
  margin-left: auto;
  padding: 24px;
  background-color: ${colors.white};

  @media ${small} {
    margin-bottom: 40px;
    padding: 4px;
  }

  @media ${desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 52px;
  }
`;

export const Form = styled.div`
  width: 100%;
`;

export const WhyTakeActionSection = styled.section`
  width: 100%;
`;
